export const chlorophyllSplashScreen = true
export const verifyEmailUpgradeAd = true
export const hamburgerMenu = false
